// component/SerendipityView.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { GoogleMap, LoadScript,Marker } from '@react-google-maps/api';
import { getCityRedirect } from '../services/api';
import BaseUrl from '../baseurlred';
import BaseUrl1 from '../BaseUrl';
import axios from "axios";


const base = BaseUrl();

const SerendipityView = () => {
  const { city } = useParams();
  const location = useLocation(); // Get current URL
  const navigate = useNavigate(); // For back navigation
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [redirectAttempted, setRedirectAttempted] = useState(false);
  const [center, setCenter] = useState({ lat: 22.7196, lng: 75.8577 });
  const [redirectViews, setRedirectViews] = useState([]);
   // Default to Indore

   const getRedirectViews = async () => {
    const url = `${BaseUrl1()}api/admin/redirect-view/all`;
    try {
      const res = await axios.get(url);

      if (res.data.success) {
        console.log("Resresrsers", res);

        setRedirectViews(res.data.Response);
      } else {
        console.warn(res.data.ResponseMessage || "Failed to fetch redirect views");
      }
    } catch (error) {
      console.error("Error fetching redirect views:", error);
      console.warn("Error fetching redirect views");
    }
  };

  useEffect(() => {
    getRedirectViews();
  }, []);
  useEffect(() => {
    const triggerRedirect = async () => {
      try {
        const redirectData = await getCityRedirect(city.toLowerCase());
  
        if (redirectData) {
          const { latitude, longitude, redirect_url } = redirectData;
          // Validate and set coordinates
          if (typeof latitude === 'number' && typeof longitude === 'number') {
            setCenter({ lat: latitude, lng: longitude });
            console.log('center:', { lat: latitude, lng: longitude });
          } else {
            console.warn('No valid coordinates found in API response for city:', city);
          }
  
          // Compare full redirect URL (your constructed one) to avoid infinite reload
          const redirect = base + city;
          console.log('redirect:', redirect);
          const currentURL = window.location.href;
  
          if (
            redirect_url &&
            redirect &&
            redirect !== currentURL &&
            !currentURL.startsWith(redirect)
          ) {
            window.location.href = redirect;
          } else {
            console.warn(
              redirect === currentURL
                ? 'Redirect URL matches current URL, skipping redirect'
                : 'No valid redirect URL found for city:',
              city
            );
            setRedirectAttempted(true); // Allow map to load
          }
        } else {
          console.warn('No valid redirect data found for city:', city);
          setRedirectAttempted(true); // Allow map to load
        }
      } catch (err) {
        console.error('Redirect error:', err.message);
        setError('Failed to fetch city data. Please try again.');
        setRedirectAttempted(true); // Allow map to load
      }
    };
  
    triggerRedirect();
  }, [city]);
  
  return (
    <div className="flex flex-col h-screen">
      {/* Back Arrow */}
      <button
        onClick={() => navigate(-1)}
        className="absolute top-4 left-4 p-2 rounded-full bg-gray-200 hover:bg-gray-300 focus:outline-none"
        title="Go Back"
      >
        <svg
          className="w-6 h-6 text-gray-700"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>

      {/* Header with Welcome Note */}
      <header className="bg-blue-600 text-white text-center  h-44  pt-8">
        <h2 className="text-3xl font-bold">
          Welcome to the {city.charAt(0).toUpperCase() + city.slice(1)} BSI view
        </h2>
      </header>

      {/* Main Content */}
      <div className="flex flex-col flex-grow -mt-20">
        <LoadScript
          googleMapsApiKey="AIzaSyBdwa9nNF-lhPPGNRPzCiXcngQNkSVw34M"
          onLoad={() => {
            console.log('Google Maps script loaded successfully');
            setScriptLoaded(true);
          }}
          onError={(err) => {
            console.error('LoadScript Error:', err);
            setError('Failed to load Google Maps. Please check your API key or network connection.');
          }}
        >
          {error ? (
            <div className="flex items-center justify-center h-full flex-col gap-4">
              <p className="text-red-500">{error}</p>
              <button
                onClick={() => window.location.reload()}
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                Retry
              </button>
            </div>
          ) : !scriptLoaded || !redirectAttempted ? (
            <div className="flex items-center justify-center h-full">
              <p className="text-slate-600">Loading map…</p>
            </div>
          ) : (
            <GoogleMap
            mapContainerStyle={{ width: '100%', height: '100%' }}
            center={center}
            zoom={8}
            options={{
              streetViewControl: false,
              fullscreenControl: true,
              mapTypeControl: false,
              mapTypeId: 'roadmap',
              minZoom: 2,
            }}
            onLoad={() => console.log('GoogleMap component loaded')}
          >
            {redirectViews.map((marker, index) => (
              <Marker
                key={index}
                position={{
                  lat: Number(marker.latitude),
                  lng: Number(marker.longitude),
                }}
                title={`${marker.city} — ${marker.redirect_url}`}
              />
            ))}
          </GoogleMap>
          
          )}
        </LoadScript>
      </div>
    </div>
  );
};

export default SerendipityView;